// extracted by mini-css-extract-plugin
export default {"cls1":"PTddeTeEf7D4knJGqRuQ","cls2":"n3dzBbLox3ON2kIoZpKf PTddeTeEf7D4knJGqRuQ"};